import api from 'api'
import { BlockStatus } from 'enum/block-status.enum'

const getScormStatus = (blockScormId: number) => {
  return api.get(`block_scorm/status/${blockScormId}`)
}

const saveLocation = (blockScormId: number, location: string) => {
  const data = {
    block_scorm_id: blockScormId,
    location: location,
  }
  return api.post('block_scorm/save_location', data)
}

const saveSuspendData = (blockScormId: number, suspendData: string) => {
  const data = {
    block_scorm_id: blockScormId,
    suspend_data: suspendData,
  }
  return api.post('block_scorm/save_suspend_data', data)
}

const saveStatus = (blockScormId: number, status: BlockStatus) => {
  const data = {
    block_scorm_id: blockScormId,
    status: status,
  }
  return api.post('block_scorm/save_status', data)
}

export const scormService = {
  getScormStatus,
  saveLocation,
  saveSuspendData,
  saveStatus,
}
